// add
const menuPanel     = document.querySelector("#menuPanel");
const menuToggle    = document.querySelector("#menuToggle");
const menuScrim     = document.querySelector("#menuScrim");
const menuClose     = document.querySelector("#menuClose");
const menuDropdown  = document.querySelectorAll(".menu-item-has-children");
// const menuClicks    = document.querySelectorAll("#menuToggle, #menuClose, #menuScrim");
const menuClicks    = document.querySelectorAll("#menuToggle, #menuClose");

const pMenu = "#menuPanel > ul";
var hasChild = false;
var subMenu = false;
var subFlag = false;
var topLevel,
    subLevel,
    current;

function isHidden(el) {
    var style = window.getComputedStyle(el);
    return style.display === "none";
}

// Toggle main menu
menuClicks.forEach(function (item) {
    item.addEventListener(
        "click",
        function (event) {
            menuToggle.classList.toggle("is-active");
            menuPanel.classList.toggle("is-active");
            // menuScrim.classList.toggle("is-active");

            document.querySelector("html, body").classList.toggle("no-scroll");

            document.querySelectorAll(".menu-item-has-children ul.is-active").forEach(function (it) {
                it.classList.remove("is-active");
            });

            toggleAriaExpanded();
            // Toggle hidden attribute on menuPanel

            if (item.id == 'menuToggle') {
                topLevel = document.querySelector(pMenu);
            }
        },
        false
    );
});

menuDropdown.forEach(function (menu) {
    menu.addEventListener(
        "click",
        function (event) {
            event.target.nextElementSibling.classList.toggle("is-active");
        },
        false
    );
});

document.addEventListener("DOMContentLoaded", function () {
    if (!isHidden(menuToggle)) {
        menuToggle.setAttribute("aria-expanded", "true");
        menuPanel.setAttribute("hidden", "hidden");
    } else {
        menuToggle.setAttribute("aria-expanded", "false");
    }
    if (document.querySelector(".menu-item-has-children")) {
        document.querySelector(".menu-item-has-children > a").addEventListener(
            "click",
            function (event) {
                if (!isHidden(menuToggle)) {
                    // event.preventDefault();
                }
            },
            false
        );
    }
});

window.addEventListener("resize", function (event) {
    if (isHidden(menuToggle)) {
        hideNavigation();
        menuToggle.setAttribute("aria-expanded", "true");
        menuPanel.removeAttribute("hidden");
    } else {
        menuToggle.setAttribute("aria-expanded", "false");
        menuPanel.setAttribute("hidden", "hidden");
    }
});

if (document.querySelectorAll(".menu-item__back")) {
    document.querySelectorAll(".menu-item__back").forEach(function(item){
        item.addEventListener(
            "click",
            function (event) {
                event.stopPropagation();
                event.preventDefault();
                event.target.closest("ul").classList.remove("is-active");
            },
            false
        );
    });
}

menuClose.addEventListener(
    "click",
    function (event) {
        hideNavigation();
        menuToggle.focus({ preventScroll: false });
    },
    false
);

function hideNavigation() {
    menuToggle.classList.remove("is-active");
    menuPanel.classList.remove("is-active");
    // menuScrim.classList.remove("is-active");
    document.querySelector("html, body").classList.remove("no-scroll");
    document.querySelector('.site-header').querySelectorAll('.is-active').forEach(function(active) {
        active.classList.remove('is-active');
    });
    menuToggle.setAttribute("aria-expanded", "false");
    menuPanel.removeAttribute("hidden");
}

function toggleAriaExpanded() {
    var toggleExpanded = menuToggle.getAttribute("aria-expanded");
    if (toggleExpanded === "false") {
        menuToggle.setAttribute("aria-expanded", "true");
        menuPanel.removeAttribute("hidden");
    } else {
        menuToggle.setAttribute("aria-expanded", "false");
        menuPanel.setAttribute("hidden", "hidden");
    }

    if (typeof menuPanel.getAttribute("hidden") === "string") {
        menuPanel.removeAttribute("hidden");
    } else {
        menuPanel.setAttribute("hidden", "hidden");
    }
}


// Keyboard nav pseudo code
// The below would only apply when focus in within the main nav.
document.addEventListener('DOMContentLoaded', function(){
    
    document.addEventListener('keydown', function(e) {
        if (e.key == 'Escape') {

            if (!subFlag) {
                if (menuToggle.classList.contains('is-active')) {
                    document.querySelector('.site-header').querySelectorAll('.is-active').forEach(function(active) {
                        active.classList.remove('is-active');
                    });
                    document.querySelector('html.no-scroll').classList.remove('no-scroll');
                    // document.querySelector('#menuScrim').classList.remove('is-active');
    
                }
            } else {
                subLevel.classList.remove('is-active');
                current = current.parentNode.closest('li');
                current.firstChild.focus();
                subFlag = false;
                subLevel = null;
                hasChild = false;
                subMenu = false;
            }
        }
    });
});

document.addEventListener("focusin", function(e){

    // Checking we are within the primary nav
    if (document.activeElement.closest(pMenu)) {

        // Assuming <ul> will always be the first element
        topLevel = document.querySelector(pMenu);

        // By default will chose <a> tag, so get parent <li> element
        current = document.activeElement.closest('li');

        /**
         * Bug fix when the user is using the tab key and then switches back 
         * to using the arrow keys. The 'current' variable was not getting set
         * correctly.
         */
        document.addEventListener('keyup', function(e) {
            if (e.key == 'Tab') {
                subLevel = null;
                hasChild = false;
                subMenu = false;
                current = e.target.closest('li');
            }
        });

        document.addEventListener('keydown', moveNavigation);
    }
});

var moveNavigation = function(e) {
    switch( e.key ) {
        case 'ArrowUp':
            if (hasChild) {
                if (current !== subLevel.firstElementChild) {
                    current = current.previousElementSibling;
                } else {
                    current = current.parentNode.closest('li');
                    subMenu = false;
                    hasChild = false;
                }
            }

            e.preventDefault();
            break;
        
        case 'ArrowLeft':
            if (!subMenu) {
                if (current !== topLevel.firstElementChild) {
                    current = current.previousElementSibling;
                }

            } else {
                current = current.parentNode.closest('li');
                subMenu = false;
            }
            break;

        case 'ArrowRight':     
            if (!subMenu) {
                if (current !== topLevel.lastElementChild) {
                    current = current.nextElementSibling;
                }

            } else {
                current = current.parentNode.closest('li');
                subMenu = false;
            }
            break;

        case 'ArrowDown':
            if (hasChild) {
                if (!subMenu) {
                    subLevel = current.querySelector('.sub-menu');
                    current = current.querySelector('.sub-menu').firstElementChild;
                    subLevel.classList.add('is-active');
                    subFlag = true;
                } else {
                    if (current !== subLevel.lastElementChild) {
                        current = current.nextElementSibling;
                    }
                }

                subMenu = true;
            }

            e.preventDefault();
            break;
    }

    if (!subMenu) {
        current.childNodes.forEach(function(item, index) {
            if (item.type !== undefined) {
                if (item.classList.contains('sub-menu')) {
                    hasChild = true;
                } else {
                    hasChild = false;
                }
            }
        }); 
    }

    current.firstChild.focus();
}
